'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

require('styles/components/product-tile/index.scss');

var _lazyloading = require('./lazyloading.js');

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Quickshop = require('components/Quickshop');

var _Quickshop2 = _interopRequireDefault(_Quickshop);

var _AnimatedButtons = require('components/AnimatedButtons');

var _AnimatedButtons2 = _interopRequireDefault(_AnimatedButtons);

var _OOSForm = require('components/OOSForm');

var _DataLayer = require('components/DataLayer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = {
  option: 'data-option-group',
  atc: 'data-atc',
  info: 'data-add-to-cart-button',
  base: 'data-base-product',
  bogo: 'data-bogo'
};

var scarcityMessaging = function scarcityMessaging(product) {
  if (product.available === false || product.tags.includes('hide-scarcity-messaging')) return '';
  var productIsNonEyewear = product.type.toLowerCase().includes('non-eye');
  var scarcityMessagingThreshold = productIsNonEyewear ? window.scarcity_messaging_inventory_threshold_noneye : window.scarcity_messaging_inventory_threshold;
  var scarcityMessaging = productIsNonEyewear ? window.scarcity_messaging_text_noneye : window.scarcity_messaging_text;

  if (product.available && product.inventory_quantity > scarcityMessagingThreshold) return '';

  return '<div class="collection__product-tag collection__product-tag--scarcity-message">' + scarcityMessaging + '</div>';
};

// Build out the list of product tags for a single product
var buildProductTags = function buildProductTags(product) {
  var tags = '';
  var settingsTags = activeTags.map(function (tag) {
    return tag.toLowerCase().split('|');
  });
  var productTags = product.tags.map(function (tag) {
    return tag.toLowerCase();
  });
  var notifyMeText = window.theme.strings.collections.notify_me;
  var soldOutText = window.theme.strings.products.product.sold_out;

  settingsTags.forEach(function (tag) {
    if (productTags.includes(tag[0])) {
      tags += '<div class="collection__product-tag" data-pass-to-parent>' + tag[0] + '</div>';
    }
  });
  if (product.comingSoon === '1' || product.comingSoon === 'true') {
    tags += '<div class="collection__product-tag collection__product-tag--coming-soon" data-coming-soon-tag data-trigger-quickkshop="' + product.handle + '">coming soon - <span data-trigger-quickkshop="' + product.handle + '" class="underline">' + notifyMeText + '</span></div>';
  } else if (false === product.available) {
    tags += '<div class="collection__product-tag collection__product-tag--oos" data-out-of-stock-tag data-trigger-quickkshop="' + product.handle + '">' + soldOutText + ' - <span data-trigger-quickkshop="' + product.handle + '" class="underline">' + notifyMeText + '</span></div>';
  }

  tags += scarcityMessaging(product);

  return tags;
};

// Build out the product tile's price
var buildProductPrice = function buildProductPrice(product) {
  if (product.isDiscounted) {
    return '<span class="price__original-value">' + product.comparePrice + '</span> <span class="price__discount-value">' + product.price + '</span>';
  } else {
    return product.price;
  }
};

var resizeImage = function resizeImage(imageURL) {
  return imageURL.replace('.png', '_x350.png').replace('.jpg', '_x400.jpg');
};

// Build out a single collection's product item
var buildProduct = function buildProduct(product) {
  var productDataLayerAttr = (0, _DataLayer.productAttrForDataLayer)({ product: product, categoryTitle: product.mainCategory, listValue: 'plp' });
  var sizesAvailableText = window.theme.strings.collections.sizes_available;
  var quickshopText = window.theme.strings.collections.quickshop;
  var doubleSize = product.mainCategory == window.theme.strings.collections.the_originals ? '<p class="collection__product--two-sizes">' + sizesAvailableText + '</p>' : '';
  var newProductEl = document.createElement('article');
  var doubleSizeText = window.theme.strings.products.product.double_wide;
  newProductEl.classList.add('collection__product');
  newProductEl.setAttribute('data-io-lazyload', '');
  newProductEl.innerHTML = '<a href="/products/' + product.handle + '" data-product-link=\'' + productDataLayerAttr + '\'>\n    <div class="collection__product-image-container" tabindex="0" role="link" data-trigger-quickkshop-key="' + product.handle + '" >\n    <div class="collection__product-tags">' + buildProductTags(product) + '</div>\n    <img class="collection__product-main-image" alt="' + product.title + ' product view" data-image-src="' + product.featuredImage + '" />\n    ' + (product.lifestyleImage ? '<img class="collection__product-lifestyle-image" alt="' + product.title + ' lifestyle view" data-image-src="' + resizeImage(product.lifestyleImage) + '"/>' : '') + '\n    ' + doubleSize + '\n    <button class="collection__product-quickshop" tabindex="1" data-trigger-quickkshop="' + product.handle + '" data-products=\'' + productDataLayerAttr + '\' aria-hidden="true">' + quickshopText + '</button>\n    </div>\n    <p class="collection__product-category">' + product.mainCategory + '</p>\n    <h2 class="collection__product-title">' + product.title + '</h2>\n    <div class="yotpo bottomLine"\n      data-product-id="' + product.id + '">\n    </div>\n    <p class="collection__product-price">' + buildProductPrice(product) + ' ' + (window.theme.strings.general.currency_code || null) + '</p>\n    </a>';
  if (product.title.toLowerCase().includes(doubleSizeText.toLowerCase())) {
    newProductEl.style.display = "none";
  };
  return newProductEl;
};

var pushKlaviyoEvent = function pushKlaviyoEvent(event) {
  var item = $(event.target).data('addToCartButton');

  window._learnq.push(['track', 'Added to Cart', item]);
};

var setupKlaviyoEvent = function setupKlaviyoEvent() {
  window._learnq = window._learnq || [];
  var $addToCartButton = $('[data-add-to-cart-button]');

  $addToCartButton.on('click', pushKlaviyoEvent);
};

var trackingGTM = function trackingGTM(products) {
  dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  dataLayer.push({
    'event': 'acn_view_item',
    'event_id': new Date().getTime() + '.' + Math.random().toString(36).substring(5),
    'ecommerce': {
      'currency': window.bvaccel.currency.currencyCode,
      'value': Number(products[0].price),
      'items': products
    }
  });
};

var variantSelector = function variantSelector() {
  if (!document.querySelector('.product__variants')) return;
  var selector = document.querySelector('.product__variants');
  var selected = document.querySelectorAll('[' + dom.option + ']:checked');
  var options = [].concat((0, _toConsumableArray3.default)(selected)).map(function (option) {
    return option.value;
  });

  selector.addEventListener('change', function (e) {
    var target = e.target,
        el = document.querySelector('.' + target.id),
        fig = el.firstElementChild,
        price = document.querySelector('.quickshop__price'),
        double = document.querySelector('.double-wide'),
        single = document.querySelector('.single-wide'),
        gtmData = el.getAttribute('data-products');
    price.textContent = target.dataset.price;
    trackingGTM(JSON.parse(gtmData));
    var atcButton = document.querySelector('[' + dom.atc + ']'),
        atcText = document.querySelector('.wides-option'),
        info = '{\n          "Name": ' + target.dataset.optionGroup + ' ,\n          "ProductID": ' + +target.value + ',\n          "Categories": ' + target.dataset.category + ',\n          "ImageURL": ' + target.dataset.image + ',\n          "URL": ' + target.dataset.url + ',\n          "Brand": "Pit Viper",\n          "Price": ' + target.dataset.price + ',\n          "CompareAtPrice": ' + target.dataset.sale + '\n        }';

    atcButton.setAttribute(dom.atc, target.dataset.variant);
    atcButton.setAttribute(dom.base, target.value);
    atcButton.setAttribute(dom.info, info);

    el.classList.add('product__variant-figure--selected');
    fig.classList.add('product__variant-figure--selected');

    if (target.id == "single-wide") {
      double.classList.remove('product__variant-figure--selected');
      double.firstElementChild.classList.remove('product__variant-figure--selected');
    } else {
      single.classList.remove('product__variant-figure--selected');
      single.firstElementChild.classList.remove('product__variant-figure--selected');
    }
    atcText.textContent = window.theme.strings.cart.general.atc;
  });
};

var charitySelector = function charitySelector() {
  if (!document.querySelector('#buyOneGiveOne')) return;
  var selector = document.querySelector('#buyOneGiveOne');
  var atcButton = document.querySelector('[' + dom.atc + ']');
  atcButton.setAttribute(dom.bogo, selector.value);
  selector.addEventListener('change', function () {
    atcButton.setAttribute(dom.bogo, selector.value);
  });
};

// build the quickshop markup
var buildProductQuickshop = function buildProductQuickshop(productData) {
  // make the request for the modal
  fetch('/products/' + productData.handle + '?view=quickshop-modal').then(function (blob) {
    return blob.text();
  }).then(function (contents) {
    var modal = document.querySelector('[data-modal-contents]');
    modal.innerHTML = contents;
    _Quickshop2.default.setupQuickshopSlider();
    charitySelector();
    variantSelector();
    _AnimatedButtons2.default.setupExplodingButtons();
    (0, _OOSForm.bvaOOS)();
    setupKlaviyoEvent();
  });
  // return just a loader for displaying while request is made
  return '';
};

// callback to trigger the quickshop
var triggerQuickshop = function triggerQuickshop(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  PubSub.publish(_Constants2.default.showModal, {
    callback: buildProductQuickshop,
    data: { handle: event.target.getAttribute('data-trigger-quickkshop') || event.target.getAttribute('data-trigger-quickkshop-key') }
  });
  var gtmData = event.target.getAttribute('data-products');
  trackingGTM([JSON.parse(gtmData)]);
};

var bindActions = function bindActions() {
  $(document).on('click', '[data-trigger-quickkshop]', triggerQuickshop);
  $(document).on('keypress', '[data-trigger-quickkshop-key]', triggerQuickshop);
};

exports.default = {
  buildProductQuickshop: buildProductQuickshop,
  buildProduct: buildProduct,
  bindActions: bindActions,
  addProductLazyLoading: _lazyloading.addProductLazyLoading,
  loadProducts: _lazyloading.loadProducts,
  resizeImage: resizeImage,
  triggerQuickshop: triggerQuickshop
};